import { useRESTv1, extendURLParams } from "@/utils/fetchData";
export const useInternetStreetsPerZipCodeAndCity = (zipCode, city, opts) => useRESTv1(`/address/streets/${zipCode}/${city}`, extendURLParams(), opts);
